import { render } from "./CityAutocomplete.vue?vue&type=template&id=20408010&scoped=true"
import script from "./CityAutocomplete.vue?vue&type=script&lang=ts"
export * from "./CityAutocomplete.vue?vue&type=script&lang=ts"

import "./CityAutocomplete.vue?vue&type=style&index=0&id=20408010&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-20408010"

export default script